import type { BoxDashboardKpiDto } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"

export class BoxDashboardKpiEntity {
  constructor(
    public readonly income: BoxDashboardKpiDto["income"] | null,
    public readonly offers: BoxDashboardKpiDto["offers"],
    public readonly activations: BoxDashboardKpiDto["activations"],
    public readonly trials: BoxDashboardKpiDto["trials"],
  ) {}

  static fromDto(dto: BoxDashboardKpiDto): BoxDashboardKpiEntity {
    return new BoxDashboardKpiEntity(dto.income, dto.offers, dto.activations, dto.trials)
  }
}

export type VariationDirection = "up" | "down" | "neutral"

export function calculateVariationDirection(
  focusValue: number,
  comparisonValue: number | null,
): VariationDirection | null {
  if (comparisonValue === null) {
    return null
  }

  if (focusValue > comparisonValue) {
    return "up"
  } else if (focusValue < comparisonValue) {
    return "down"
  }
  return "neutral"
}

export function calculateVariation(focus: number, comparison: number | null): number | null {
  if (comparison === null) {
    return null
  }

  return Math.abs(focus - comparison)
}
